import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import './ItemCard.css';
import './ItemList.css';
import CardTitleRow from './CardTitleRow';
import LoadErrorScreen from './LoadErrorScreen';

const getPhotoUrl = (photo) => {
  if (!photo || typeof photo !== 'string') return null;
  const t = photo.trim();
  if (!t) return null;
  if (t.startsWith('http://') || t.startsWith('https://')) return t;
  if (t.startsWith('/')) return `${process.env.REACT_APP_SERVER_URL}${t}`;
  return `${process.env.REACT_APP_SERVER_URL}/${t}`;
};

const getFirstPhoto = (tour) => {
  const photos = tour.photos;
  if (!photos || !Array.isArray(photos) || photos.length === 0) return null;
  for (const p of photos) {
    const url = getPhotoUrl(p);
    if (url) return url;
  }
  return null;
};

const ToursPage = () => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setLoadError(false);
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/tours/public?limit=120`)
      .then((r) => {
        if (!r.ok) throw new Error('Ошибка загрузки туров');
        return r.json();
      })
      .then((data) => setTours(Array.isArray(data?.tours) ? data.tours : []))
      .catch(() => {
        setLoadError(true);
        setTours([]);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress sx={{ color: '#8B7D6B' }} />
      </Box>
    );
  }

  if (loadError) {
    return <LoadErrorScreen />;
  }

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden', px: 0.25, mx: 0, mt: 2 }}>
      <Grid container spacing={1} className="items-grid-container" sx={{ px: 0.5, overflowX: 'hidden', maxWidth: '100%' }}>
        {tours.length > 0 ? (
          tours.map((tour, index) => {
            const photoUrl = getFirstPhoto(tour) || 'https://via.placeholder.com/300';
            const isAboveFold = index < 8;
            return (
              <Grid item xs={6} sm={6} md={4} lg={true} key={tour._id || tour.tourNumber} className="item-grid-item">
                <Card
                  component={Link}
                  to={`/tours/${tour.tourNumber}`}
                  className="card-container"
                  sx={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', height: '100%' }}
                >
                  <Box sx={{ position: 'relative' }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        zIndex: 1,
                        backgroundColor: '#5B7DB1',
                        color: '#fff',
                        px: 1,
                        py: 0.25,
                        borderRadius: '8px',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                      }}
                    >
                      Тур
                    </Box>
                    <div className="slider-image-container">
                      <img
                        src={photoUrl}
                        alt={tour.title || 'Тур'}
                        className="card-image"
                        loading={isAboveFold ? 'eager' : 'lazy'}
                        decoding="async"
                        onError={(e) => { e.target.src = 'https://via.placeholder.com/300'; }}
                      />
                    </div>
                  </Box>
                  <CardContent className="card-content">
                    <CardTitleRow type="tour" entityId={tour._id}>
                      {tour.title}
                    </CardTitleRow>
                    <Typography className="card-price" sx={{ fontWeight: 'bold', color: '#2e7d32', fontSize: '0.85rem' }}>
                      {tour.price != null ? `${Number(tour.price).toLocaleString('ru-RU')} ₽ / место` : 'Цена по запросу'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block">
                      {tour.destination || 'Направление уточняется'}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })
        ) : (
          <Typography className="no-items-message" sx={{ gridColumn: '1 / -1' }}>
            Пока нет туров
          </Typography>
        )}
      </Grid>
    </Box>
  );
};

export default ToursPage;
